
import {map} from 'rxjs/operators';
import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {forkJoin} from "rxjs";
import {ClientQuestion} from "../../../../../swaggerServices";
import {ClientCategoryService} from "../../../../../swaggerServices";
import {ClientQuestionService} from "../../../../../swaggerServices";
import {ActivatedRoute} from "@angular/router";
import { cloneDeep } from "lodash-es";
import { groupBy } from "lodash-es";
import {ClientCategory} from "../../../../../swaggerServices";
import {IFormField} from "../../../../shared/components/form-field-wrapper/form-field-wrapper.component";
import {ConfigStateService} from "../../../config/config-state.service";
import {Tenant} from "../../../../shared/types/tenant.enum";
import { environment } from '../../../../environments/environment'

declare var $: any;

interface IClientQuestion extends ClientQuestion {
  canRemove?: boolean
}

interface IClientCategory extends ClientCategory {
  isCollapsed?: boolean;
  questions?: IClientQuestion[];
  order?: number
  newCategoryName?: string
  newCategoryOrder?: number
}

@Component({
    selector: 'app-client-rules-builder',
    templateUrl: './client-rules-builder.component.html',
    styleUrls: ['./client-rules-builder.component.scss'],
    standalone: false
})
export class ClientRulesBuilderComponent implements OnInit {
  activeTab: 'categories' | 'questions' = 'categories';
  isReady: boolean;
  categories: IClientCategory[];
  originalCategories: IClientCategory[];
  categorySearch: string;
  newCategoryName: string;
  newCategoryOrder: number;
  questions: IClientQuestion[];
  questionSearch: string;
  originalQuestions: IClientQuestion[];
  selectedNode: {
    type?: 'Category' | 'Question'
    category?: IClientCategory
    question?: {
      id: number
      question: string
      newQuestionOrder: number
      order?: number
    },
  };
  isSaving: boolean;
  @ViewChild('editModal') editModal: ElementRef;
  @ViewChild('newCategoryModal') newCategoryModal: ElementRef;
  @ViewChild('addQuestionToCategoryModal') addQuestionToCategoryModal: ElementRef;
  @ViewChild('confirmDeleteModal') confirmDeleteModal: ElementRef;
  addCategoryQuestionSearch: string;
  taxYear: number;
  showQuestionId: boolean;
  isProductionMode: boolean;

  constructor(
    private clientCategoryService: ClientCategoryService,
    private clientQuestionService: ClientQuestionService,
    private config: ConfigStateService,
    private activatedRoute: ActivatedRoute
  ) {
    this.isProductionMode = environment.production;
  }

  ngOnInit() {
    this.init();
  }

  init() {
    forkJoin([
      this.getCategories(),
      this.getQuestionsByyear(),
    ]).subscribe(() => {
      this.initStrucutre();
      this.showQuestionId = this.config.tenant !== Tenant.AU;
    });
  }

  getCategories() {
    return this.clientCategoryService.getClientCategorys().pipe(map((d: ClientCategory[]) => {
      this.categories = d;
    }));
  }

  showCreateCategoryModal() {
    this.newCategoryName = null;
    this.newCategoryOrder = null;
    $(this.newCategoryModal.nativeElement).modal('show');
  }

  // when creating category, need to get new id from api in order to get id, all other list updates are handled locally
  addCategory() {
    const category = {
      id: null,
      name: this.newCategoryName,
      newCategoryOrder: this.newCategoryOrder,
      questions: []
    };
    // add to list
    this.categories.push(category);
    this.updateOrders({category});
    $(this.newCategoryModal.nativeElement).modal('hide');
  }

  getTaxYearParam() {
    return {taxYear: this.taxYear};
  }

  getQuestionsByyear() {
    const taxYr = this.activatedRoute.queryParams['value'].taxYear;
    this.taxYear = taxYr;
    return this.clientQuestionService.getClientQuestionsByyear(taxYr).pipe(map((d: any) => {
      this.originalQuestions = cloneDeep(d.clientQuestions);
      this.questions = d.clientQuestions;
    }))
  }

  initStrucutre() {

    this.categories.forEach(c => {
      c.isCollapsed = true;
      c.questions = this.questions.filter(q => q.clientCategoryId === c.id);
    });

    this.originalCategories = cloneDeep(this.categories);
    this.initOrders();
    this.isReady = true;
    this.isSaving = false;

  }

  // whenever an order is updated via UI, need to update the order within the array structure as well
  initOrders() {
    this.categories = this.categories
      .filter(c => c.order != null)
      .sort((a, b) => a.order - b.order)
      .concat(this.categories.filter(c => c.order == null));

    this.categories.forEach(c => {
      c.questions.forEach(q => {
        const qsByParentId = groupBy(c.questions.filter(q => q.parentId), q => q.parentId);
        c.questions = c.questions
          .filter(q => q.order != null && q.parentId == null)
          .sort((a, b) => a.order - b.order)
          .concat(c.questions.filter(q => q.order == null && q.parentId == null));
        for (const tableQuestionId of Object.keys(qsByParentId)) {
          let tableCols = qsByParentId[tableQuestionId];
          tableCols = tableCols
            .filter(q => q.order != null)
            .sort((a, b) => a.order - b.order)
            .concat(tableCols.filter(q => q.order == null));
          const tableQuestionIdNumber = Number(tableQuestionId);
          const index = c.questions.findIndex(q => q.id === tableQuestionIdNumber);
          if (index >= 0) {
            c.questions.splice(index + 1, 0, ...tableCols);
          }
        }
      });
    });

  }

  editNode(category?, question?) {

    this.selectedNode = {};

    if (category) {
      this.selectedNode.category = category;
      this.selectedNode.type = 'Category';
      category.isCollapsed = category.isCollapsed = !category.isCollapsed
    }

    else if (question) {
      this.selectedNode.question = question;
      this.selectedNode.type = 'Question';
    }

  }

  showEditModal() {
    this.reset();

    $(this.editModal.nativeElement).modal({
      onDeny: () => {
        this.reset();
      },
      onApprove: () => {
        this.updateOrders(this.selectedNode);
      }
    }).modal('show');
  }

  reset() {
    if (this.selectedNode.category) {
      this.selectedNode.category.newCategoryName = this.selectedNode.category.name;
      this.selectedNode.category.newCategoryOrder = this.selectedNode.category.order;
    }
    else if (this.selectedNode.question)
      this.selectedNode.question.newQuestionOrder = this.selectedNode.question.order;
  }

  updateOrders(selectedNode) {
    if (selectedNode.category) {
      if (selectedNode.category.newCategoryName) {
        selectedNode.category.name = selectedNode.category.newCategoryName;
      }

      // ensure it takes precedence over other items with duplicate orders
      if (selectedNode.category.order !== selectedNode.category.newCategoryOrder) {
        const dup = this.categories.find(c => c.order === selectedNode.category.newCategoryOrder);
        if (dup) {
          const movingDown = selectedNode.category.newCategoryOrder > selectedNode.category.order;
          this.categories.forEach(c => {
            if (c.order < selectedNode.category.newCategoryOrder) {
              c.order--;
            } else if (c.order > selectedNode.category.newCategoryOrder) {
              c.order++;
            } else {
              c.order += movingDown ? -1 : 1;
            }
          });
        }
        selectedNode.category.order = selectedNode.category.newCategoryOrder;
        this.initOrders();
      }
    } else if (selectedNode.question) {
      // ensure it takes precedence over other items with duplicate orders
      if (selectedNode.question.order !== selectedNode.question.newQuestionOrder) {
        let category;
        this.categories.forEach(c => {
          if (c.questions.find(q => q.id === selectedNode.question.id)) category = c;
        });
        const dup = category.questions.find(q => q.order === selectedNode.question.newQuestionOrder);
        if (dup) {
          const movingDown = selectedNode.question.newQuestionOrder > selectedNode.question.order;
          category.questions.forEach(q => {
            if (q.order < selectedNode.question.newQuestionOrder) {
              q.order--;
            } else if (q.order > selectedNode.question.newQuestionOrder) {
              q.order++;
            } else {
              q.order += movingDown ? -1 : 1;
            }
          });
        }
        selectedNode.question.order = selectedNode.question.newQuestionOrder;
        this.initOrders();
      }
    }

    this.categories.forEach((c, cIndex) => {
      c.order = cIndex + 1;
      c.questions.forEach((q, qIndex) => {
        q.order = qIndex + 1;
      });
    });

  }

  getQuestionType(q: IFormField): string {
    let questionType = q.displayFieldType;
    if (q.displayFieldType === 'text') {
      if (q.dataType === 'string') {
        questionType = 'text';
      }
      if (q.dataType.toLowerCase() === 'integer' || q.dataType.toLowerCase() === 'float') {
        questionType = 'number';
      }
    }
    return questionType;
  };

  showAddQuestionToCategoryModal() {
    this.addCategoryQuestionSearch = null;
    $(this.addQuestionToCategoryModal.nativeElement).modal('show');
  }

  // filter out questions that haven't already been used
  canAddQuestion(q) {
    let usedQ;
    this.categories.forEach(c => {
      if (c.questions && c.questions.find(_q => _q.id === q.id)) usedQ = true;
    });
    return !usedQ
  }

  addQuestionToCategory(q: IClientQuestion) {

    // for dependant mandatory question to be added
    if (q.dependantMandatoryParentId && !this.selectedNode.category.questions.find(_q => _q.id === q.dependantMandatoryParentId)) {
      const depQ = this.questions.find(_q => _q.id === q.dependantMandatoryParentId);
      return alert("This question is dependant on the question '" + depQ.question + "'. You must first add that question to this category.");
    }

    // if adding a column q, must add the table q
    else if (q.parentId) {
      if (!this.selectedNode.category.questions.find(_q => _q.id === q.parentId)) {
        const tableQ = this.questions.find(_q => _q.id === q.parentId);
        return alert("This is a column question for the table '" + tableQ.question + "'. You must first add that question to this category.");
      }
    }

    else {

      q.order = this.selectedNode.category.questions.length + 1;

      this.selectedNode.category.questions.push({
        ...q,
        canRemove: true
      });
      // find all column questions and add to category
      this.questions.forEach(_q => {
        if (_q.parentId === q.id) {
          this.selectedNode.category.questions.push({
            ..._q,
            canRemove: true
          });
        }
      });

      this.updateOrders({question: q});
      this.selectedNode.category.isCollapsed = false;
      $(this.addQuestionToCategoryModal.nativeElement).modal('hide');

    }

  }

  showConfirmDeleteModal(type: 'category' | 'question',
                         item: IClientCategory | IClientQuestion | any,
                         category?: IClientCategory) {

    $(this.confirmDeleteModal.nativeElement).modal({

      onApprove: () => {

        if (type === 'category') {
          this.categories = this.categories.filter(c =>
            // when adding multiple new items, can only compare against name
            c.name !== item.name);
        }

        // if removing table question, also remove column questions
        else if (type === 'question') {
          category.questions = category.questions.filter(q => q.id !== item.id);
          if (item.displayFieldType === 'table')
            category.questions = category.questions.filter(q => q.parentId !== item.id);

        }
        this.updateOrders({});
      }
    }).modal('show');

  }

  // child items rely on parent item ids, need save new parent items before associating them to child items
  save() {
    this.isSaving = true;

    const categoryObs = [];
    const questionObs = [];

    // handle category changes
    const handleCategory = () => {

      this.categories.forEach((c) => {

        let originalCategory;
        this.originalCategories.forEach(_c => {
          if (_c.id === c.id) originalCategory = _c;
        });

        // new category
        if (!c.id) {
          categoryObs.push(this.clientCategoryService.addClientCategory({
            name: c.name,
            order: c.order
          }).pipe(map((_c) => {
            // append id
            c.id = _c.id;
            handleQuestions(c, null);
          })));
        }

        // existing category
        else {

          if (c.name !== originalCategory.name || c.order !== originalCategory.order) {
            categoryObs.push(this.clientCategoryService.updateClientCategory({
              id: c.id,
              name: c.name,
              order: c.order
            }));
          }
          handleQuestions(c, originalCategory);
        }

      });

    };


    const handleQuestions = (c, originalCategory) => {

      c.questions.forEach(q => {
        const originalQuestion = originalCategory && originalCategory.questions.find(_q => _q.id === q.id);
        if (!originalQuestion || q.order !== originalQuestion.order) {
          questionObs.push(this.clientQuestionService.updateClientQuestion({
            id: q.id,
            question: q.question, // api needs this
            clientCategoryId: c.id,
            order: q.order,
          }));
        }
      });

    };

    const handleCategoryObs = () => {

      if (categoryObs.length > 0) {
        forkJoin(categoryObs).subscribe((d) => {
            handleQuestionObs();
          },
          () => this.isSaving = false);
      }
      else {
        handleQuestionObs();
      }

    };

    const handleQuestionObs = () => {

      if (questionObs.length > 0) {
        forkJoin(questionObs).subscribe(() => {
            this.init();
          },
          () => this.isSaving = false);
      } else {
        // only re-init if there are changes
        const hasChanges = [].concat(categoryObs, questionObs).length > 0;
        if (hasChanges) this.init();
        else this.isSaving = false;
      }

    };

    handleCategory();
    handleCategoryObs();

  }


}
